import { createContext, ReactNode, useContext } from 'react';
import { createPortal } from 'react-dom';

/**
 * The element in the page header bar, right after the title, where a page
 * can show a subtitle ("12 resultados para “banker”"). Provided by
 * `ByxPageLayout`; null outside it or before the header has mounted.
 */
export const PageSubtitleSlotContext = createContext<HTMLElement | null>(null);

/**
 * Renders its children in the header bar next to the page title. The page
 * keeps owning the content (and its updates); the header only hosts it.
 */
export function PageSubtitle(props: Readonly<{ children: ReactNode }>) {
  const slot = useContext(PageSubtitleSlotContext);
  return slot ? createPortal(props.children, slot) : null;
}
